import { currentCartCrd } from '../account/reducer';
import { ORDER_TYPE_FUTURES } from '../shop/constants';
import { getSelectedDepartment } from '../shop/selectors';
import { isBetween } from '../util/date';
import {
  CHINA_SALES_ORGS,
  CHINA_SALES_ORG,
  HONG_KONG_SALES_ORG,
  TAIWAN_SALES_ORG,
  EU_SALES_ORGS,
  NA_SALES_ORGS,
  MANA_SALES_ORG,
  AUSTRALIA_SALES_ORGS,
  JAPAN_SALES_ORGS,
  US_SALES_ORG
} from '../util/constants';

export const getGamedayAccount = state => state.gamedayAccount;

export const accountIsBillable = state => {
  const account = getGamedayAccount(state);
  return account.allotments ? account.allotments.billable : true;
};

export const getCurrentAllotments = state => getGamedayAccount(state).allotments?.currentAllotment;

// TODO: Current Cart CRD is part of account. Move it into gameday account?

/**
 * @name getFutureAllotments
 * @param {*} state
 * @param {*} ignoreCartCrd use this when you wish to deal with the literal future allotment
 * data irrespective of the currentCartCrd logic
 */
export const getFutureAllotments = (state, ignoreCartCrd = false) => {
  const crd = currentCartCrd(state);
  const current = getCurrentAllotments(state);

  return !ignoreCartCrd &&
    crd &&
    current &&
    isBetween({
      start: current.contractStartDate,
      end: current.contractEndDate,
      date: crd,
      inclusiveStart: true,
      inclusiveEnd: true
    })
    ? current
    : getGamedayAccount(state).allotments?.futureAllotment;
};

export const getAllotmentsForSelectedDepartment = state => {
  const selectedDepartment = getSelectedDepartment(state);
  if (!selectedDepartment) return {}; // should we have default structure here?

  const { type, number } = selectedDepartment;
  const allotments = type === ORDER_TYPE_FUTURES ? getFutureAllotments(state) : getCurrentAllotments(state);

  return allotments?.departments?.[+number];
};

export const getAllDepartments = state => ({
  ...getCurrentAllotments(state)?.departments,
  ...getFutureAllotments(state)?.departments
});

export const getDepartmentNameForNumber = (state, departmentNumber) => {
  const department = getAllDepartments(state)[departmentNumber];
  return department ? department.departmentName : '';
};

export const getCountryProvinces = state => {
  return getGamedayAccount(state)?.provinces;
};

export const getSalesOrg = state => {
  return getGamedayAccount(state)?.salesOrgCode;
};

export const getIsGreaterChinaSalesOrg = state => {
  return !!CHINA_SALES_ORGS.includes(getSalesOrg(state));
};

export const getIsChinaSalesOrg = state => {
  return getSalesOrg(state) === CHINA_SALES_ORG;
};

export const getIsUSSalesOrg = state => {
  return getSalesOrg(state) === US_SALES_ORG;
};

export const getIsHongKongOrTaiwanSalesOrg = state => {
  const salesOrg = getSalesOrg(state);
  return salesOrg === HONG_KONG_SALES_ORG || salesOrg === TAIWAN_SALES_ORG;
};

export const getIsMANASalesOrg = state => {
  return getSalesOrg(state) === MANA_SALES_ORG;
};

export const getIsShoppingEnabled = state => {
  return getGamedayAccount(state)?.shoppingEnabled ?? true;
};

export const getIsEUSalesOrg = state => {
  const salesOrg = getSalesOrg(state);
  return EU_SALES_ORGS.includes(salesOrg);
};

export const getIsNASalesOrg = state => {
  const salesOrg = getSalesOrg(state);
  return NA_SALES_ORGS.includes(salesOrg);
};

export const getIsAustraliaSalesOrg = state => {
  const salesOrg = getSalesOrg(state);
  return AUSTRALIA_SALES_ORGS.includes(salesOrg);
};

export const getIsJapanSalesOrg = state => {
  const salesOrg = getSalesOrg(state);
  return JAPAN_SALES_ORGS.includes(salesOrg);
};
